module.exports = __webpack_public_path__ + "img/J8.7d7602c8.png";